import MelitaeaPortrait from "../assets/characters/Melitaea.png";
import LeontinePortrait from "../assets/characters/Léontine.png";
import LoudianaPortrait from "../assets/characters/Loudiana.png";
import EurydicePortrait from "../assets/characters/Eurydice.png";
import MelusinePortrait from "../assets/characters/Mélusine.png";
import JingxiPortrait from "../assets/characters/Jingxi.png";
import NefertaryPortrait from "../assets/characters/Nefertary.png";
import ZamsellyPortrait from "../assets/characters/Zamselly.png";
import GauvinPortrait from "../assets/characters/Gauvin.png";
import AurelienPortrait from "../assets/characters/Aurélien.png";
import QuintiusPortrait from "../assets/characters/Quintius.png";
import HippolytePortrait from "../assets/characters/Hippolyte.png";
import MelchiorPortrait from "../assets/characters/Melchior.png";
import BarthelemyPortrait from "../assets/characters/Barthélemy.png";
import AlaricPortrait from "../assets/characters/Alaric.png";
import JesusPortrait from "../assets/characters/Jésus.png";

export const QUEST_CHARACTERS = {
  melitaea: {
    id: "melitaea",
    displayName: "Melitaea",
    specialty: "Personnages de fiction",
    portrait: MelitaeaPortrait,
  },
  leontine: {
    id: "leontine",
    displayName: "Léontine",
    specialty: "Paradoxes du langage",
    portrait: LeontinePortrait,
  },
  loudiana: {
    id: "loudiana",
    displayName: "Loudiana",
    specialty: "Histoire du livre",
    portrait: LoudianaPortrait,
  },
  eurydice: {
    id: "eurydice",
    displayName: "Eurydice",
    specialty: "Mythes fondateurs",
    portrait: EurydicePortrait,
  },
  melusine: {
    id: "melusine",
    displayName: "Mélusine",
    specialty: "Livres qui ont changé le monde",
    portrait: MelusinePortrait,
  },
  jingxi: {
    id: "jingxi",
    displayName: "Jingxi",
    specialty: "Grands mouvements littéraires",
    portrait: JingxiPortrait,
  },
  nefertary: {
    id: "nefertary",
    displayName: "Nefertary",
    specialty: "Citations commentées",
    portrait: NefertaryPortrait,
  },
  zamselly: {
    id: "zamselly",
    displayName: "Zamselly",
    specialty: "Curiosités lexicales",
    portrait: ZamsellyPortrait,
  },
  gauvin: {
    id: "gauvin",
    displayName: "Gauvin",
    specialty: "Psychologie cognitive",
    portrait: GauvinPortrait,
  },
  aurelien: {
    id: "aurelien",
    displayName: "Aurélien",
    specialty: "Figures de style",
    portrait: AurelienPortrait,
  },
  quintius: {
    id: "quintius",
    displayName: "Quintius",
    specialty: "Histoire de la langue française",
    portrait: QuintiusPortrait,
  },
  hippolyte: {
    id: "hippolyte",
    displayName: "Hippolyte",
    specialty: "Étymologie",
    portrait: HippolytePortrait,
  },
  melchior: {
    id: "melchior",
    displayName: "Melchior",
    specialty: "Civilisations disparues",
    portrait: MelchiorPortrait,
  },
  barthelemy: {
    id: "barthelemy",
    displayName: "Barthélemy",
    specialty: "Philosophie",
    portrait: BarthelemyPortrait,
  },
  alaric: {
    id: "alaric",
    displayName: "Alaric",
    specialty: "Vies d'auteurs",
    portrait: AlaricPortrait,
  },
  jesus: {
    id: "jesus",
    displayName: "Jésus",
    specialty: "Messages bibliques",
    portrait: JesusPortrait,
  },
};

export function getQuestCharacter(characterId) {
  return QUEST_CHARACTERS[characterId] || null;
}

export function getQuestCharacterPortrait(characterId) {
  return getQuestCharacter(characterId)?.portrait || null;
}
